import { useNavigate } from "react-router-dom";
import { AuthContainer } from "../components/Auth/AuthContainer";
import { StartPagePresentational } from "../components/StartPage/StartPagePresentational";
import { ComponentProps, useEffect } from "react";
import { showLogin } from "../services/login-service";
import { AuthenticationStatus, getAuthStatus } from "../services/authenticator-service";

export const StartPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    async function getAuthState() {
      const authState = await getAuthStatus();

      if (authState === AuthenticationStatus.LoggedIn) {
        onAuthSuccess();
      }
    }

    getAuthState().catch((error: unknown) => {
      console.error(error);
    });
  }, [navigate]);

  const onAuthSuccess = () => {
    navigate("/");
  };
  return <StartPageInjectable {...{ onAuthSuccess, openLoginDialog: showLogin }} />;
};

export const StartPageInjectable = (props: ComponentProps<typeof AuthContainer>) => (
  <div className="m-0 w-full h-full relative">
    <div className="m-0 w-full h-full">
      <div className="flex flex-col flex-grow min-h-0 max-h-full">
        <StartPagePresentational>
          <AuthContainer onAuthSuccess={props.onAuthSuccess} openLoginDialog={props.openLoginDialog} />
        </StartPagePresentational>
      </div>
    </div>
    <div className="absolute bottom-0 left-0 m-4 text-xs font-thin text-neutral-600">1.0.65</div>
  </div>
);
